import script from "./CouponDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponDetail.vue?vue&type=script&setup=true&lang=js"

import "./CouponDetail.vue?vue&type=style&index=0&id=de02dbc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de02dbc0"]])

export default __exports__